import React from 'react';
import { Link, navigate } from 'gatsby';

import * as styles from './header-pwa.module.scss';
import LogoIcon from '../../assets/images/svg/logo-sygnet.svg';
import TrainingIcon from '../../assets/images/svg/training.svg';
import DietIcon from '../../assets/images/svg/diet.svg';
import DevelopmentIcon from '../../assets/images/svg/development.svg';
import PrizeIcon from '../../assets/images/svg/prize.svg';

interface IHeaderPWAProps {
    className?: string;
}

const HeaderPWA = ({ className = '' }: IHeaderPWAProps) => {
    const handleBack = (fallbackHref: string) => {
        return () => {
            if (window.history.length <= 1) {
                void navigate(fallbackHref);
                return;
            }
            void navigate(-1);
        };
    };
    return (
        <>
            <div className={styles.spacer} />
            <div className={`${styles.container} ${className}`}>
                {links.map((link, index) => {
                    const Icon = link.icon;
                    if (link.role === 'return-link') {
                        return (
                            <button
                                className={`${styles.link} ${styles.returnLink}`}
                                key={`header-pwa-link-${index}`}
                                onClick={handleBack(link.href)}
                            >
                                <Icon className={styles.icon} />
                            </button>
                        );
                    }
                    return (
                        <Link
                            className={styles.link}
                            key={`header-pwa-link-${index}`}
                            to={link.href}
                        >
                            <Icon className={styles.icon} />
                            <p className={styles.label}>{link.label}</p>
                        </Link>
                    );
                })}
            </div>
        </>
    );
};

const links = [
    {
        label: 'Jadłospis',
        href: '/app/planer-posilkow',
        icon: DietIcon,
        role: 'link',
    },
    {
        label: 'Trening',
        href: '/app/trening-personalny/biezacy-trening',
        icon: TrainingIcon,
        role: 'link',
    },
    {
        label: '',
        href: '/app/moje-konto/strefa-uzytkownika/witaj',
        icon: LogoIcon,
        role: 'return-link',
    },
    {
        label: 'Raporty i efekty',
        href: '/app/moje-konto/przemiana/raport-dzienny',
        icon: DevelopmentIcon,
        role: 'link',
    },
    {
        label: 'Nagrody',
        href: '/app/moje-konto/twoje-ketony/wstep',
        icon: PrizeIcon,
        role: 'link',
    },
];

export default HeaderPWA;
